import {
  BannerImgBg,
  BannerImgMobile,
  BannerLink,
  BannerWrapper,
  WebsiteLabel,
} from "./styles";
import { Box, MainContainer, Image } from "../../../styles/basicStyles";
import { useTranslation } from "next-i18next";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import Typography from "../../../components/typography";

interface BannerProps {
  imageDesktop?: string;
  imageMobile?: string;
  logo?: string;
  bgColorDesktop?: string;
  bgColorMobile?: string;
  titleColor?: string;
  titleDetail?: string;
  subtitle?: string;
  androidLink?: string;
  iosLink?: string;
  websiteLink?: string;
}

const Banner: FC<BannerProps> = ({
  imageDesktop,
  imageMobile,
  logo,
  bgColorDesktop,
  bgColorMobile,
  titleColor,
  titleDetail,
  subtitle,
  androidLink,
  iosLink,
  websiteLink,
}) => {
  const { t } = useTranslation();

  return (
    <BannerWrapper fDirection="column" backgroundColor={{ md: bgColorDesktop, xxs: bgColorMobile }}>
      <BannerImgBg
        mt={5}
        url={imageDesktop}
        h={{ md: 36.25, xxs: "auto" }}
      >
        <MainContainer>
          <Box fDirection="column">
            <Image
              src={logo}
              mb={{ md: 5, xxs: 1.875 }}
              maxW={7.5}
              maxH={4.375}
              alt='logo'
            />
            <Typography
              as='h1'
              fSize={{ md: 3, xxs: 2.188 }}
              lHeight={{ md: 3.625, xxs: 2.625 }}
              fWeight={700}
              maxW={31.25}
              color={titleColor}
            >
              {titleDetail}
            </Typography>
            <Typography
              as='h2'
              fSize={{ md: 1.75, xxs: 1.25 }}
              lHeight={{ md: 2.125, xxs: 1.563 }}
              fWeight={400}
              color={titleColor}
              maxW={31.25}
              mt={{ md: 1.875, xxs: 1.25 }}
            >
              {subtitle}
            </Typography>
            <Box display={{ md: "none", xxs: "flex" }}>
              <BannerImgMobile src={imageMobile} alt='detail mobile image'/>
            </Box>
            <Box
              mt={4.688}
              fWrap="wrap"
              fJustify={{ md: "flex-start", xxs: "center" }}
            >
              {androidLink && (
                <BannerLink href={androidLink} target="_blank" rel="noreferrer" aria-label="Get app android">
                  <Image src="/assets/android_store.svg" alt='get app android' />
                </BannerLink>
              )}
              {iosLink && (
                <BannerLink href={iosLink} target="_blank" rel="noreferrer" aria-label="Get app ios">
                  <Image src="/assets/ios_store.svg" alt='get app ios' />
                </BannerLink>
              )}
              {websiteLink && (
                <BannerLink href={websiteLink} target="_blank" rel="noreferrer">
                  <WebsiteLabel>
                    <Typography
                      fSize={1}
                      lHeight={1.188}
                      fWeight={400}
                      color={colors.white}
                    >
                      {t("CHECK_OUT_THE_WEBSITE")}
                    </Typography>
                  </WebsiteLabel>
                </BannerLink>
              )}
            </Box>
          </Box>
        </MainContainer>
      </BannerImgBg>
    </BannerWrapper>
  );
};

export default Banner;
